export const loadImage = (imageName: string) => {
  return process.env.PUBLIC_URL + '/img/' + imageName;
};
